import { Question, FormProps } from '../EventTypes';

export const emptyQuestion = {
  id: '',
  text: '',
  type: 'Custom',
  answerType: 'Text',
  answerDestination: 'Invitation',
  isRequired: false,
  options: [
    {
      text: '',
      description: '',
    },
    {
      text: '',
      description: '',
    },
  ],
};

// normalizeQuestion populates any null/undefined properties with empty strings
// in order to play nice with union fields.
export const normalizeQuestion = (question: Question): FormProps => {
  const noramlizedQuestion = { ...question };
  noramlizedQuestion.text = noramlizedQuestion.text ?? '';
  noramlizedQuestion.type = noramlizedQuestion.type ?? '';
  noramlizedQuestion.answerType = noramlizedQuestion.answerType ?? '';
  noramlizedQuestion.answerDestination = noramlizedQuestion.answerDestination ?? '';

  noramlizedQuestion.options = noramlizedQuestion.options?.map(option => ({
    ...option,
    text: option.text ?? '',
    description: option.description ?? '',
  }));

  return noramlizedQuestion as FormProps;
};
